import { Injectable } from '@angular/core';
import { Database, get, ref } from '@angular/fire/database';
import { data } from 'autoprefixer';


@Injectable({
  providedIn: 'root'
})
export class ContentService {
  get contentStore(): { exercises2: {}; weblinks: {} } {
    this._contentStore = JSON.parse(localStorage.getItem('content'))
    return this._contentStore;
  }

  set contentStore(value: { exercises2: {}; weblinks: {} }) {
    this._contentStore = value;
    localStorage.setItem('content', JSON.stringify(this._contentStore))
  }


  private _contentStore: { exercises2: {}, weblinks: {} } = { exercises2: {}, weblinks: {} }
  constructor(private db: Database) {

  }

  /**
   * Loads all necessary content and caches it.
   */
  public async loadInitialContent(): Promise<void> {
    await this.fetchAndCache('weblinks', '/v1/content/en/weblinks').then();
    await this.fetchAndCache('exercises2', '/v1/content/en/exercises2').then();
  }

  private async fetchAndCache(contentKey: string, dbPath: string): Promise<any> {

    try {
      const dbRef = ref(this.db, dbPath);
      const snapshot = await get(dbRef);

      if (snapshot.exists()) {
        const data = snapshot.val();

        this._contentStore = this._contentStore ?? { exercises2: {}, weblinks: {} };

        this._contentStore[contentKey] = data;
        this.contentStore = { ...this._contentStore };
        return data;
      } else {
        console.warn(`No data found at path: ${dbPath}`);
        return null;
      }
    } catch (error) {
      console.error(`Error fetching data from ${dbPath}:`, error);
      return null;
    }
  }

  getById(id: string): any {
    let contentItem = this.contentStore?.weblinks?.[id];

    if (!contentItem) {
      contentItem = this.contentStore?.exercises2?.[id];
    }

    return contentItem;
  }
}
